export default __webpack_public_path__ + "static/media/Girdle of the Riftcaller.b2acb3ce.jpg";